export default "__VITE_ASSET__Bo7zpcN3__"